import { Link } from "react-router-dom";
import RadioSearchNav from "@shared/cards/RadioSearchNav";
import { SearchCard2 } from "@shared/cards";

interface ExploreSearchSectionProps {
  intent: string;
  page: number;
  setPage: (page: number) => void;
  filtersLoaded: boolean;
  setFiltersLoaded: (loaded: boolean) => void;
  isMobile?: boolean;
  onTypeChange?: (type: string) => void;
  user?: any;
  limit?: number;
}

export const ExploreSearchSection = ({
  intent,
  page,
  setPage,
  filtersLoaded,
  setFiltersLoaded,
  isMobile = false,
  onTypeChange,
  user,
  limit = 12,
}: ExploreSearchSectionProps) => {
  const handleTypeChange = (newType: string) => {
    if (onTypeChange) {
      onTypeChange(newType);
    }
  };

  return (
    <section className=" mb-5">
      {!isMobile && (
        <h4 className="fw-500 mb-4">
          Hello,{" "}
          <span className="fw-600">
            {user?.firstname || user?.lastname || ""}
          </span>
        </h4>
      )}
      <h5 className="fw-600 mb-3">List of Properties</h5>
      <div className="col-12 rounded">
        {isMobile && (
          <div className="d-lg-none">
            <RadioSearchNav
              type={intent}
              setPage={setPage}
              onTypeChange={handleTypeChange}
            />
          </div>
        )}
        {!isMobile && (
          <div>
            <RadioSearchNav
              type={intent}
              setPage={setPage}
              onTypeChange={handleTypeChange}
            />
          </div>
        )}
        <hr
          style={{
            borderColor: "#f0f0f0",
            borderWidth: "1px",
            opacity: 0.5,
            marginTop: 0,
          }}
        />
        <SearchCard2
          extraClass="rounded-top-left-0 rounded-top-right-0"
          sizeClass={isMobile ? "col-md-4 col-8" : "col-md-4 col-8"}
          page={page}
          setPage={setPage}
          limit={limit}
        />
      </div>

      {filtersLoaded && (
        <Link
          className="btn btn-link fw-bold px-0 text-danger ml-1 no-decoration"
          to="/explore"
          onClick={() => setFiltersLoaded(false)}
        >
          Clear Filters
        </Link>
      )}
    </section>
  );
};
